import { useMemo, ReactNode } from 'react';

import { useToken } from 'src/features/auth';
import { useGetPermissions } from 'src/features/auth/api/useGetPermissions';
import AuthContext from 'src/features/auth/context/AuthContext';
import { useParking } from 'src/providers/ParkingProvider';
import { SettingsProvider } from 'src/providers/SettingsProvider';

function AuthProvider({ children }: { children: ReactNode }) {
    const { data: tokenData, isPending: isTokenPending } = useToken();
    const { parkingId } = useParking();
    const { data: permissions, isLoading: isPermissionsLoading } = useGetPermissions({
        config: { enabled: !!tokenData },
        parking: parkingId,
    });

    // const { data: userData } = useGetUser({
    //     config: { enabled: !!tokenData && !!tokenData.sub },
    //     userId: tokenData ? tokenData.sub : '',
    // });

    const value = useMemo(
        () => ({
            user: null, //TODO: pass userData once we have it
            permissions: permissions || [],
            permissionsLoaded: !isTokenPending && !isPermissionsLoading,
        }),
        [permissions, isPermissionsLoading, isTokenPending],
    );

    return (
        <AuthContext.Provider value={value}>
            <SettingsProvider>{children}</SettingsProvider>
        </AuthContext.Provider>
    );
}

export { AuthProvider };
